export default __webpack_public_path__ + "static/media/single-shadow-horizontal.4f8320cf.svg";